import React, {
    memo,
    useState,
    useMemo,
    lazy,
    Suspense,
    useEffect,
} from "react";
import { Loading } from "components/shared";
import { useDispatch, useSelector } from "react-redux";
import {
    LAYOUT_TYPE_CLASSIC,
    LAYOUT_TYPE_MODERN,
    LAYOUT_TYPE_SIMPLE,
    LAYOUT_TYPE_STACKED_SIDE,
    LAYOUT_TYPE_DECKED,
    LAYOUT_TYPE_BLANK,
} from "constants/theme.constant";
import useAuth from "utils/hooks/useAuth";
import useDirection from "utils/hooks/useDirection";
import useLocale from "utils/hooks/useLocale";
import { validateToken } from "store/auth/userSlice";

const layouts = {
    [LAYOUT_TYPE_CLASSIC]: lazy(() => import("./ClassicLayout")),
    [LAYOUT_TYPE_MODERN]: lazy(() => import("./ModernLayout")),
    [LAYOUT_TYPE_STACKED_SIDE]: lazy(() => import("./StackedSideLayout")),
    [LAYOUT_TYPE_SIMPLE]: lazy(() => import("./SimpleLayout")),
    [LAYOUT_TYPE_DECKED]: lazy(() => import("./DeckedLayout")),
    [LAYOUT_TYPE_BLANK]: lazy(() => import("./BlankLayout")),
};

const Layout = () => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const layoutType = useSelector((state) => state.theme.layout.type);
    const { isPageLoading } = useSelector((state) => state.base.common);

    const { authenticated, signOut } = useAuth();

    useDirection();

    useLocale();

    useEffect(() => {
        if (authenticated) {
            setLoading(true);
            // dispatch(validateToken())
            //     .then(async (action) => {
            //         if (!action.payload) {
            //             await signOut();
            //         }
            //         setLoading(false);
            //     })
            //     .catch(() => {});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authenticated, dispatch]);

    const AppLayout = useMemo(() => {
        if (authenticated) {
            return layouts[layoutType];
        }
        return lazy(() => import("./AuthLayout"));
    }, [layoutType, authenticated]);

    if (loading) {
        <div className="flex flex-auto flex-col h-[100vh]">
            <Loading loading={true} />
        </div>;
    }

    return (
        <Suspense
            fallback={
                <div className="flex flex-auto flex-col h-[100vh]">
                    <Loading loading={true} />
                </div>
            }
        >
            <Loading loading={isPageLoading} type="page">
                <AppLayout />
            </Loading>
        </Suspense>
    );
};

export default memo(Layout);
